import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getAuctions, getCategories, getStates } from "../../api";
import LgSearch from "../../components/Lg_search";
import ConvertToArabicNumbers from "../../utils/convert_numbers";
import SmallSearch from "../../components/small_search";
import FillterModal from "../../components/fillter_modal";
import LoadingCircle from "./component/loading";
import notFound from "../../images/not-found.png";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";
import Client from "../../utils/client";
import { useAuth } from "../../store/authProvider";

const Auction = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Crops Auctions",
  });
  const navigator = useNavigate();
  const [crop, setCrop] = useState([]);
  const [state, setState] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [auction, setAuction] = useState([]);
  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });
  const { data: categories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const onSubmit = (search) => {
    refetch();
  };

  const {
    data: auctions,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["auctions"],
    queryFn: () =>
      getAuctions(
        state.map((e) => e.value),
        crop.map((e) => e.value),
        getValues().search_word === ""
          ? getValues().search_words
          : getValues().search_word
      ),
    initialData: [],
    onSuccess: (data) => setAuction(data),
  });
  const isAuth = useAuth();

  const getAuction = async (id) => {
    navigator(`/home/single_auction/${id}`);
    const user_id = localStorage.getItem("user_id");
    await Client.post("/admin/logs", {
      user_id: isAuth.isAuth ? user_id : null,
      action: "Product View",
      product_type: "Crops Auction Product",
      product_id: id.toString(),
    });
  };

  return (
    <div className="grid w-11/12 grid-cols-2 gap-5  lg:w-[81rem] lg:gap-2 lg:grid-flow-row lg:grid-cols-5 mx-6 lg:mx-0 lg:px-20 mt-10">
      <Helmet>
        ‍<title>المزادات - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="المزادات | محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      {showFilters && (
        <FillterModal
          categories={categories}
          crop={crop}
          setCrop={setCrop}
          setShowFilters={setShowFilters}
          states={states}
          setState={setState}
          state={state}
          name="المحصول"
        />
      )}
      <SmallSearch
        page={6}
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        categories={categories}
        states={states}
        crop={crop}
        state={state}
        setState={setState}
        setCrop={setCrop}
        setShowFilters={setShowFilters}
        text="إضافة مزاد"
      />
      <LgSearch
        page={6}
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        setShowFilters={setShowFilters}
        text="إضافة مزاد"
      />

      {isFetching ? (
        <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
          <LoadingCircle />
        </div>
      ) : auctions.length === 0 ? (
        <div className="flex flex-col col-span-2 mt-20 justify-center text-center lg:col-span-5">
          <div className="font-bold mx-auto">
            <img src={notFound} />
          </div>
          <div className="h-6"></div>
          <div className="flex items-center mx-auto justify-center h-12 text-lg font-bold ">
            عذراً لا توجد مزادات جارية
          </div>
        </div>
      ) : (
        auction.map((item) => (
          <div
            className={`relative flex flex-col items-center overflow-hidden w-full bg-white border-2 ${
              item.status !== "Open" ? "" : "hover:scale-105 cursor-pointer"
            }  transition   border-primary rounded-2xl  h-[17rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl`}
            key={item.id}
            onClick={() => (item.status !== "Open" ? "" : getAuction(item.id))}
          >
            {/* {isAuth && item.owner === localStorage.getItem("user_id") && (
                        <Link to={editLink}>
                            <div className="absolute right-0 text-gray-400 p-2">{edit_icon}</div>
                        </Link>
                    )} */}
            {item.status === "Pending" && (
              <div className="absolute w-[95%] mb-1 h-[45%] bottom-0 backdrop-blur-[4px] text-center flex justify-center items-center ">
                <div className="flex flex-col-reverse gap-3 font-bold text-[#008000]">
                  قريباََ{" "}
                  <p className="scale-75 text-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="59.675"
                      height="63.688"
                      viewBox="0 0 59.675 63.688"
                      className="mx-auto"
                    >
                      <path
                        id="Clock-Icon-SVG-03cdfcf3"
                        d="M7.206,50.354l11.555-2.141-3.524,5.125a25.949,25.949,0,0,0,16.328,3.118c.382-.058.771-.121,1.157-.187a25.919,25.919,0,0,0,11.485-5.255A18.33,18.33,0,0,0,45.853,49.6a24.585,24.585,0,0,0,3.614-4.213c.224-.3.427-.612.621-.932a9.654,9.654,0,0,0,.571-.955,3.109,3.109,0,0,0,.19-.309,5.324,5.324,0,0,0,.34-.675,19.658,19.658,0,0,0,1.023-2.228c.1-.251.207-.516.3-.777a.217.217,0,0,0,.055-.152,14.672,14.672,0,0,0,.63-2.007c.017-.032.03-.041.017-.057a6.954,6.954,0,0,0,.216-.866c.09-.369.168-.715.239-1.084A12.841,12.841,0,0,0,53.872,34c.076-.449.113-.894.146-1.347.029-.29.044-.588.057-.879.015-.4.031-.807.031-1.2,0-.56-.015-1.1-.058-1.643v-.076c-.029-.485-.076-.952-.135-1.422-.026-.145-.04-.291-.057-.443-.056-.393-.116-.8-.191-1.2a1.83,1.83,0,0,0-.07-.319c-.092-.5-.206-.982-.341-1.481a1.713,1.713,0,0,1-.069-.305c-.147-.506-.294-1.017-.472-1.517a.187.187,0,0,1-.012-.041c-.176-.517-.373-1.029-.573-1.529-.017-.013-.017-.043-.029-.059a15.916,15.916,0,0,0-.7-1.548,14.493,14.493,0,0,0-.69-1.312c-.276-.5-.585-.991-.913-1.492-.2-.314-.41-.618-.638-.923a11.129,11.129,0,0,0-.676-.9,10.02,10.02,0,0,0-.723-.862,7.233,7.233,0,0,0-.743-.84,20.432,20.432,0,0,0-2.435-2.274A17.424,17.424,0,0,0,42.9,9.113a.48.48,0,0,0-.171-.12,6.162,6.162,0,0,0-.872-.567,6.97,6.97,0,0,0-.95-.58c-.1-.069-.206-.131-.305-.189a6.822,6.822,0,0,0-.678-.342,17.229,17.229,0,0,0-2.012-.932,8.941,8.941,0,0,0-1.056-.412A15.8,15.8,0,0,0,34.734,5.3C34,5.09,33.247,4.929,32.516,4.8a19.162,19.162,0,0,0-2.139-.284.452.452,0,0,0-.205-.01c-.337-.05-.658-.061-1-.079-.4-.029-.8-.029-1.2-.029-.555,0-1.1.015-1.642.058H26.25c-.5.03-.982.073-1.462.146a2.843,2.843,0,0,0-.41.05c-.4.049-.8.117-1.206.187-.1.018-.206.043-.3.07-.429.08-.87.178-1.292.3-.149.031-.293.058-.443.1A26.081,26.081,0,0,0,5.06,17.894c-.335.63-.631,1.263-.92,1.9L0,18.263c.367-.837.765-1.67,1.215-2.5a30.438,30.438,0,0,1,18.453-14.6c.322-.087.663-.2,1-.265.467-.116.937-.22,1.4-.324.311-.057.623-.1.927-.158C23.543.326,24.067.259,24.615.2A13.448,13.448,0,0,1,26.007.073a8.115,8.115,0,0,1,.846-.041,22.95,22.95,0,0,1,2.6.012c.383.016.747.03,1.129.079.5.027,1,.081,1.495.154.4.063.8.118,1.172.194a.047.047,0,0,1,.063,0,33.239,33.239,0,0,1,3.809.942,21.252,21.252,0,0,1,2.466.893c.457.183.91.378,1.367.584.425.226.864.445,1.291.663s.849.477,1.273.718.839.51,1.247.778.814.541,1.19.837c.365.267.724.531,1.058.8a1.141,1.141,0,0,0,.2.161c.732.6,1.437,1.218,2.1,1.863.613.62,1.217,1.246,1.791,1.911.274.321.54.644.817.982a28.382,28.382,0,0,1,1.951,2.79c.163.261.319.521.482.791.045.07.077.141.121.217.148.229.274.479.409.731.487.9.922,1.835,1.321,2.789.1.274.218.57.335.867.118.321.22.626.337.952.1.307.2.631.308.956.09.3.193.627.265.945.159.591.292,1.162.427,1.751.073.392.143.789.216,1.2.056.317.1.655.152.979.084.675.144,1.338.186,2.009a7.488,7.488,0,0,1,.049.842c.04.859.026,1.723-.018,2.6-.016.384-.031.764-.074,1.138-.033.463-.088.915-.144,1.382-.061.428-.136.86-.211,1.277a.083.083,0,0,1,0,.061c-.158.867-.35,1.7-.571,2.554v.012c-.222.807-.466,1.6-.746,2.39a.45.45,0,0,1-.047.1c-.311.824-.627,1.631-1,2.42-.17.356-.349.717-.509,1.068a.7.7,0,0,1-.056.11c-.21.373-.417.76-.632,1.144-.428.747-.9,1.478-1.383,2.2A29.318,29.318,0,0,1,48.8,52.864a30.949,30.949,0,0,1-10.11,6.216l.018.071a30.744,30.744,0,0,1-5.176,1.436c-.22.043-.445.091-.66.123a30.3,30.3,0,0,1-20.127-3.746l-3.4,4.946Zm32.226-5.171-8.51-5.295a5.811,5.811,0,0,0,2.424-3.745L41.792,41.4a2.232,2.232,0,0,1-2.36,3.788ZM23.509,34.854a4.17,4.17,0,1,1,4.17,4.168A4.171,4.171,0,0,1,23.509,34.854Zm2-24.906a2.169,2.169,0,0,1,4.333,0V29.615a5.878,5.878,0,0,0-2.153-.41,5.951,5.951,0,0,0-2.181.417Z"
                        transform="translate(0.671 0.499)"
                        stroke="rgba(0,0,0,0)"
                        strokeMiterlimit="10"
                        strokeWidth="1"
                        fill="green"
                      />
                    </svg>
                  </p>
                </div>
              </div>
            )}
            {item.status === "Closed" && (
              <div className="absolute w-[95%] mb-1 h-[45%] bottom-0 backdrop-blur-[3px] text-center flex justify-center items-center ">
                <div className="flex flex-col-reverse gap-3 font-bold text-red-600">
                  منتهي
                </div>
              </div>
            )}
            <img
              src={item._sub_category.image}
              className="lg:h-2/4 h-32 mt-2"
              alt=""
            />
            <div className="flex row items-center" dir="rtl">
              <div className="font-bold text-lg my-1">
                {item._sub_category.name}
              </div>
            </div>
            <div
              className="lg:text-lg text-md mb-0.5"
              dir="rtl"
            >{`${ConvertToArabicNumbers(item.quantity)} ${
              item._unit.name
            }`}</div>
            <div className="text-lg mb-1">{item._state.name}</div>
            <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">
              <div className="flex flex-row space-x-3 mb-2"></div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Auction;
